@for (branch of branches; track branch; let index = $index) {
    <fui-navigation-branch id="branch-{{index}}" [branch]="branch"></fui-navigation-branch>
}
